import React, { useEffect } from "react";

const AddLocation = ({
  errors,
  lang,
  register,
  clearErrors,
  setDisclosureData,
  disclosureData,
  disclosure,
  setShowMap,
  setValue,
  openMapForDisclosure,
  getValues,
  setError,
  enPhrase,
  arPhrase,
}) => {
  useEffect(() => {
    if (disclosureData[disclosure?.id]?.location) {
      setValue(
        `location-${disclosure?.id}`,
        disclosureData[disclosure?.id]?.location
      );
    }
  }, [disclosureData[disclosure?.id]?.location]);

  console.log("getValues", getValues(`location-${disclosure?.id}`));

  return (
    <div className="w-full flex flex-col gap-4">
      <div>
        <label
          htmlFor={`location-${disclosure?.id}`}
          className={`block text-sm ${
            errors[`location-${disclosure?.id}`] &&
            !disclosureData[disclosure?.id]?.locationName
              ? "text-red-600 font-normal"
              : "text-gray-700 font-bold"
          }`}
        >
          {lang === "en"
            ? enPhrase["lblDefineLocation"]
            : arPhrase["lblDefineLocation"]}
        </label>

        <div className="relative">
          <input
            type="hidden"
            id={`location-${disclosure?.id}`}
            {...register(`location-${disclosure?.id}`, { required: true })}
          />

          <button
            type="button"
            onClick={(e) => {
              e.preventDefault(); // Prevent form validation
              // document.body.style.overflow = "hidden";
              openMapForDisclosure(disclosure.id);
              // window.scrollTo(0, 0)
            }}
            className={`mt-1 w-full rounded-md h-10 shadow-sm focus:border-gold-100 focus:ring-gold-100 sm:text-sm bg-white border border-[1px] ${
              errors[`location-${disclosure?.id}`] &&
              !disclosureData[disclosure?.id]?.locationName
                ? "!border-red-600"
                : "border-gray-300 "
            } px-2 flex items-center justify-start overflow-hidden whitespace-nowrap text-ellipsis`}
          >
            <span
              className={`max-w-[90%] overflow-hidden whitespace-nowrap truncate font-Almarai font-normal text-[14px] leading-[20px]  ${
                disclosureData[disclosure?.id]?.locationName
                  ? "text-[#333]"
                  : "text-gray-500"
              }`}
            >
              {disclosureData[disclosure?.id]?.locationName
                ? disclosureData[disclosure?.id]?.locationName
                : lang === "en"
                ? enPhrase["lblSelectLocation"]
                : arPhrase["lblSelectLocation"]}
            </span>
          </button>

          <img
            src="/assets/img/add-request/AddLocation/location.svg"
            alt="location"
            className={`w-9 h-9 absolute ${
              lang === "en" ? "right-1" : "left-1"
            } top-1`}
          />
        </div>

        {errors[`location-${disclosure?.id}`] &&
          !disclosureData[disclosure?.id]?.locationName && (
            <span role="alert" className="text-xs text-red-600">
              {lang === "en"
                ? enPhrase["lblErrorSelectLocation"]
                : arPhrase["lblErrorSelectLocation"]}
            </span>
          )}
      </div>

      <div>
        <label
          //   htmlFor="makaniLocation"
          htmlFor={`makaniLocation-${disclosure?.id}`}
          className={`block text-[12px]  ${
            errors[`makaniLocation-${disclosure?.id}`]
              ? " text-[#E61A05] font-normal"
              : "text-gray-700 font-bold"
          }`}
        >
          {lang === "en"
            ? enPhrase["lblMakaniLocation"]
            : arPhrase["lblMakaniLocation"]}
        </label>
        <div className="relative">
          <input
            type="text"
            maxLength={10}
            name={`makaniLocation-${disclosure?.id}`}
            key="makaniLocation"
            placeholder={
              lang === "en"
                ? enPhrase["lblPlaceholderMakani"]
                : arPhrase["lblPlaceholderMakani"]
            }
            aria-invalid={errors.makaniLocation ? "true" : "false"}
            onKeyDown={(e) => {
              // Allow: Backspace, Delete, Tab, Escape, Enter, Arrow keys
              if (
                [
                  "Backspace",
                  "Delete",
                  "Tab",
                  "Escape",
                  "Enter",
                  "ArrowLeft",
                  "ArrowRight",
                ].includes(e.key)
              ) {
                return;
              }
              // Block if not a number
              if (!/^\d$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            {...register(`makaniLocation-${disclosure?.id}`, {
              validate: (value) => {
                if (!value) return true;
                return (
                  /^\d{10}$/.test(value) ||
                  (lang === "en"
                    ? enPhrase["lblErrorMakaniLocation"]
                    : arPhrase["lblErrorMakaniLocation"])
                );
              },
              onChange: (e) => {
                setDisclosureData((prev) => ({
                  ...prev,
                  [disclosure?.id]: {
                    ...prev[disclosure?.id],
                    makaniLocation: e.target.value,
                  },
                }));
              },
              onBlur: (e) => {
                const value = e.target.value;
                if (!value) {
                  clearErrors(`makaniLocation-${disclosure?.id}`);
                } else if (!/^\d{10}$/.test(value)) {
                  setError(`makaniLocation-${disclosure?.id}`, {
                    type: "manual",
                    message:
                      lang === "en"
                        ? enPhrase["lblErrorMakaniLocation"]
                        : arPhrase["lblErrorMakaniLocation"],
                  });
                } else {
                  clearErrors(`makaniLocation-${disclosure?.id}`);
                }
              },
            })}
            className={`mt-1 block w-full rounded-md h-[40px] shadow-sm focus:border-gold-100 focus:ring-gold-100 sm:text-sm !text-[13px] font-[500] leading-[20px] ${
              errors[`makaniLocation-${disclosure?.id}`]
                ? " border-red-600"
                : " border-gray-300"
            }`}
          />
          <img
            src="/assets/img/add-request/AddLocation/makani_logo.svg"
            alt="loction"
            className={`w-[44px] h-[20px] md:w-[70px] md:h-[32px] flex items-end  absolute  top-2 md:top-[2px] ${
              lang === "en" ? "right-4" : "left-4"
            }`}
          />
        </div>
        {errors[`makaniLocation-${disclosure?.id}`] && (
          <span role="alert" className="text-xs text-red-600">
            {errors[`makaniLocation-${disclosure?.id}`]?.message ||
              (lang === "en"
                ? enPhrase["lblValidMakaniLocation"]
                : arPhrase["lblValidMakaniLocation"])}
          </span>
        )}
      </div>
    </div>
  );
};

export default AddLocation;
